export default __webpack_public_path__ + "786c9eb7590c5021976b1ae1ae47826b.svg";